"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DeveloperSettingsProvider = void 0;
const react_1 = __importStar(require("react"));
const DeveloperSettingsContext_1 = require("./DeveloperSettingsContext");
const DEVELOPER_SETTINGS_KEY = "@developer_settings";
const DEFAULT_SETTINGS = {
    developerModeEnabled: false,
};
// Default localStorage adapter for web
const localStorageAdapter = {
    getItem: (key) => __awaiter(void 0, void 0, void 0, function* () { return localStorage.getItem(key); }),
    setItem: (key, value) => __awaiter(void 0, void 0, void 0, function* () { return localStorage.setItem(key, value); }),
};
const DeveloperSettingsProvider = ({ children, storageAdapter = localStorageAdapter, }) => {
    const [settings, setSettings] = (0, react_1.useState)(DEFAULT_SETTINGS);
    (0, react_1.useEffect)(() => {
        const loadSettings = () => __awaiter(void 0, void 0, void 0, function* () {
            try {
                const stored = yield storageAdapter.getItem(DEVELOPER_SETTINGS_KEY);
                if (stored) {
                    setSettings(JSON.parse(stored));
                }
            }
            catch (error) {
                console.error("[DeveloperSettingsProvider] Error loading settings:", error);
            }
        });
        loadSettings();
    }, [storageAdapter]);
    const saveSettings = (0, react_1.useCallback)((newSettings) => __awaiter(void 0, void 0, void 0, function* () {
        try {
            yield storageAdapter.setItem(DEVELOPER_SETTINGS_KEY, JSON.stringify(newSettings));
        }
        catch (error) {
            console.error("[DeveloperSettingsProvider] Error saving settings:", error);
        }
    }), [storageAdapter]);
    const setDeveloperModeEnabled = (0, react_1.useCallback)((enabled) => {
        setSettings(prev => {
            const newSettings = Object.assign(Object.assign({}, prev), { developerModeEnabled: enabled });
            saveSettings(newSettings);
            return newSettings;
        });
    }, [saveSettings]);
    return (react_1.default.createElement(DeveloperSettingsContext_1.DeveloperSettingsContext.Provider, { value: {
            developerModeEnabled: settings.developerModeEnabled,
            setDeveloperModeEnabled,
        } }, children));
};
exports.DeveloperSettingsProvider = DeveloperSettingsProvider;
